var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 590 590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1f1f1f;}.cls-2{fill:#fa8c16;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8D44\u6E90 59") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295,
    cy: 295,
    r: 295,
    transform: "translate(-122.19 295) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.4,210.3l127.06-73.36a14.17,14.17,0,0,1,14.14,0l80,46.21a14.14,14.14,0,0,1,3,22.23l-27.13,27.27a14.14,14.14,0,0,1-17.1,2.27l-38.61-22.29a14.44,14.44,0,0,0-14.44,0l-134,78.12v-68.2A14.16,14.16,0,0,1,178.4,210.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M399.92,406.68,319.6,453.06a14.17,14.17,0,0,1-14.14,0L178.4,379.7a14.16,14.16,0,0,1-7.07-12.25V305.59l65.47-37.95v62a14.16,14.16,0,0,0,7.07,12.25l61.59,35.56a14.17,14.17,0,0,0,14.14,0l39-22.5a14.14,14.14,0,0,1,17.07,2.25l27.21,27.21A14.15,14.15,0,0,1,399.92,406.68Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruLogo);
export default __webpack_public_path__ + "static/media/cru-logo.cf3452d4f5a042743eeb0373922de9dd.svg";
export { ForwardRef as ReactComponent };